﻿import { DataRequest } from 'shared/data/datarequest';

export class FileFieldMetadata extends DataRequest {
    constructor(public identifier: string, public fieldName: string, public allowedTypes: string, public maxSize: number) {
        super();

        this.$type = 'Web.FileFieldMetadata';
    }
}
